import React from "react";
import { Select, Button } from "antd";
import dayjs from "dayjs";
import { $t } from "~/i18n.js";
import { Radio } from "antd";
import { TimeFormat } from "~/components/date/TimeFormat.jsx";
import { Tag } from "antd";
import { DateFormat } from "~/components/date/DateFormat.jsx";

function getAvailableSlotsForDate(date, product, bookedTimeslots) {
  if (!date || !product) return [];
  const calendarAvailability = product.calendar_availability || {};
  const duration = parseInt(product.duration, 10) || 60;
  const weekday = dayjs(date).locale("en").format("dddd").toLowerCase();
  const slotRanges = calendarAvailability[weekday] || [];

  let slots = [];

  // bookedTimeslots is now a dictionary: { [date]: { [timeslot]: number_booked } }
  const bookedForDate =
    bookedTimeslots && typeof bookedTimeslots[date] === "object"
      ? bookedTimeslots[date]
      : {};

  slotRanges.forEach(([start, end]) => {
    let current = dayjs(date + " " + start);
    const endTime = dayjs(date + " " + end);
    // Only check if the start time fits in the slot
    while (current.isBefore(endTime)) {
      const slotStart = current.format("HH:mm");
      const slotEnd = current.add(duration, "minute").format("HH:mm");

      // Get number booked for this slot
      const number_booked = bookedForDate[slotStart] || 0;
      let disabled = false;
      if (product.max_per_slot > 0 && number_booked >= product.max_per_slot) {
        disabled = true;
      }
      let color = "#52c41a"; // green by default
      if (product.max_per_slot > 0) {
        if (number_booked >= product.max_per_slot) {
          color = "#ff4d4f"; // red
        } else if (number_booked > 0) {
          color = "#faad14"; // yellow
        }
      }
      slots.push({
        label: (
          <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span style={{ width: 100 }}>
              {slotStart} - {slotEnd}
            </span>
            <span
              style={{
                display: "inline-block",
                width: 14,
                height: 14,
                borderRadius: "50%",
                background: color,
              }}
            />
            {product.max_per_slot > 0
              ? ` ${number_booked} / ${product.max_per_slot}`
              : ""}
          </span>
        ),
        value: slotStart,
        disabled,
        sortKey: slotStart,
      });
      current = current.add(duration, "minute");
    }
  });
  // Sort slots by start time
  slots.sort((a, b) => a.sortKey.localeCompare(b.sortKey));
  return slots;
}

export default function StepReservering({
  editMode,
  product,
  checkoutItem,
  setCheckoutItem,
  availableDays,
  bookedTimeslots,
  onNext,
  onPrev,
}) {
  if (!product) return null;

  // Build list of bookable dates
  let dayOptions = [];
  if (availableDays && availableDays.length > 0) {
    dayOptions = availableDays.map((date) => ({
      label: dayjs(date).format("dddd D MMMM YYYY"),
      value: date,
    }));
  }

  // Get available slots for selected date
  const availableSlots = checkoutItem.date
    ? getAvailableSlotsForDate(checkoutItem.date, product, bookedTimeslots)
    : [];

  const canContinue = !!checkoutItem.date && !!checkoutItem.timeslot;

  return (
    <>
      <div>
        {editMode && (
          <div
            className="row"
            style={{ alignItems: "flex-start", gap: 8, marginBottom: 12 }}
          >
            <p className="label title spacer">{$t("Wijzig huidige keuze")}</p>
            <Tag>
              {checkoutItem.reserved_timeslot ? (
                <DateFormat
                  date={checkoutItem.reserved_timeslot}
                  options={{
                    weekday: "short",
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                    hour: "2-digit",
                    minute: "2-digit",
                  }}
                />
              ) : (
                $t("Geen tijdslot")
              )}
            </Tag>
          </div>
        )}

        <p className="label title spacer">{$t("Kies een datum")}</p>
        <Select
          style={{ width: "100%" }}
          placeholder={$t("Selecteer een datum")}
          options={dayOptions}
          value={checkoutItem.date || undefined}
          onChange={(value) =>
            setCheckoutItem({
              ...checkoutItem,
              date: value,
              timeslot: undefined,
              reserved_timeslot: undefined,
            })
          }
        />
        {checkoutItem.date && (
          <div style={{ marginTop: 24 }}>
            <p className="label title spacer">{$t("Kies een tijdslot")}</p>

            <Radio.Group
              options={availableSlots}
              value={checkoutItem.timeslot}
              onChange={(e) => {
                setCheckoutItem({
                  ...checkoutItem,
                  timeslot: e.target.value,
                  reserved_timeslot: checkoutItem.date + " " + e.target.value,
                });
              }}
              style={{ display: "flex", flexDirection: "column", gap: 8 }}
            />
          </div>
        )}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: 24,
        }}
      >
        <Button onClick={onPrev}>{$t("Terug")}</Button>
        <Button type="primary" onClick={onNext} disabled={!canContinue}>
          {$t("Volgende")}
        </Button>
      </div>
    </>
  );
}
